module.exports = __webpack_public_path__ + "static/CircularStd-Book-df11411b6232f336b5cf95340c5f680a.ttf";